/**
 * Stone Investment Blog Grid
 *
 * Legacy BlogGrid with Stone's editorial aesthetic:
 * greyscale cards, square corners, Cormorant Garamond headings.
 */

'use client';

import type { BlogGridProps } from '@routeroyal/theme-core';
import { StoneBlogCard } from './StoneBlogCard';

export function StoneBlogGrid({
  articles,
  variant = 'grid',
  columns = 3,
  emptyMessage = 'No articles found',
  locale = 'en',
  className = '',
}: BlogGridProps) {
  if (articles.length === 0) {
    return (
      <div className="text-center py-16">
        <p
          className="text-stone-500 text-lg"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          {emptyMessage}
        </p>
      </div>
    );
  }

  const isList = variant === 'list';

  const gridClasses = isList
    ? 'space-y-8'
    : `grid gap-8 ${
        columns === 1
          ? 'grid-cols-1'
          : columns === 2
          ? 'grid-cols-1 md:grid-cols-2'
          : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'
      }`;

  const featuredArticle = !isList && articles.length > 0 ? articles[0] : null;
  const regularArticles = !isList && articles.length > 0 ? articles.slice(1) : articles;

  return (
    <div className={className}>
      {featuredArticle && (
        <div className="mb-12">
          <StoneBlogCard
            article={featuredArticle}
            variant="featured"
            showExcerpt={true}
            showCategory={true}
            showAuthor={true}
            locale={locale}
          />
        </div>
      )}

      {regularArticles.length > 0 && (
        <div className={gridClasses}>
          {regularArticles.map((article) => (
            <StoneBlogCard
              key={article.id}
              article={article}
              variant={isList ? 'compact' : 'default'}
              showExcerpt={!isList}
              showCategory={true}
              showAuthor={true}
              locale={locale}
            />
          ))}
        </div>
      )}
    </div>
  );
}
